/**
 * Delivery Timer Badge
 * Netherlands time (Europe/Amsterdam) | Cut-off: 23:00 | Business days: Mon–Fri
 * Countdown: Mon–Thu 21:00–22:59, Sun 21:00–22:59
 */
const TIMEZONE = 'Europe/Amsterdam';
const CUTOFF_HOUR = 23;
const COUNTDOWN_START_HOUR = 21;

function getNetherlandsNow() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: TIMEZONE }));
}

function getNLDay(date) {
  return date.toLocaleDateString('en-US', { weekday: 'short', timeZone: TIMEZONE });
}

function getNLHours(date) {
  return date.toLocaleTimeString('en-US', { hour: '2-digit', hour12: false, timeZone: TIMEZONE });
}

function getNLMinutes(date) {
  return date.toLocaleTimeString('en-US', { minute: '2-digit', timeZone: TIMEZONE });
}

function getNLTimeParts(date) {
  const str = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: TIMEZONE,
  });
  const [h, m, s] = str.split(':').map(Number);
  return { hours: h, minutes: m, seconds: s };
}

function getState(now) {
  const day = getNLDay(now);
  const { hours } = getNLTimeParts(now);

  if (day === 'Fri') {
    return { key: 'friday', showCountdown: false };
  }
  if (day === 'Sat') {
    return { key: 'saturday', showCountdown: false };
  }
  if (day === 'Sun') {
    if (hours >= CUTOFF_HOUR) return { key: 'sunday_after_cutoff', showCountdown: false };
    if (hours >= COUNTDOWN_START_HOUR) return { key: 'sunday_countdown', showCountdown: true };
    return { key: 'sunday_before_cutoff', showCountdown: false };
  }
  // Mon–Thu
  if (hours >= CUTOFF_HOUR) return { key: 'mon_thu_after_cutoff', showCountdown: false };
  if (hours >= COUNTDOWN_START_HOUR) return { key: 'mon_thu_countdown', showCountdown: true };
  return { key: 'mon_thu_before_cutoff', showCountdown: false };
}

function getCountdownTo2300(now) {
  const { hours, minutes, seconds } = getNLTimeParts(now);
  let remainingSeconds = (CUTOFF_HOUR - 1 - hours) * 3600 + (59 - minutes) * 60 + (60 - seconds);
  if (remainingSeconds <= 0) return null;
  const h = Math.floor(remainingSeconds / 3600);
  const m = Math.floor((remainingSeconds % 3600) / 60);
  const s = remainingSeconds % 60;
  return { h, m, s, totalSeconds: remainingSeconds };
}

function formatCountdown({ h, m, s }) {
  const parts = [];
  if (h > 0) parts.push(`${h}h`);
  parts.push(`${m}m`);
  if (h === 0) parts.push(`${s}s`);
  return parts.join(' ');
}

function initDeliveryTimerBadge(el) {
  const prefixEl = el.querySelector('[data-delivery-timer-prefix]');
  const countdownEl = el.querySelector('[data-delivery-timer-countdown]');
  const suffixEl = el.querySelector('[data-delivery-timer-suffix]');
  let messages = {};
  try {
    messages = JSON.parse(el.dataset.messages || '{}');
  } catch (_) {}

  const countdownPlaceholder = el.dataset.countdownPlaceholder || '[[COUNTDOWN]]';
  const timePlaceholder = el.dataset.timePlaceholder || '[[TIME]]';
  const cutoffTime = el.dataset.cutoffTime || '23:00';

  function update() {
    const now = getNetherlandsNow();
    const state = getState(now);

    let message = messages[state.key] || '';
    let showCountdown = state.showCountdown;

    if (showCountdown) {
      const countdown = getCountdownTo2300(now);
      if (countdown && countdown.totalSeconds > 0) {
        const countdownStr = formatCountdown(countdown);
        const parts = message.split(countdownPlaceholder);
        prefixEl.textContent = parts[0] || '';
        countdownEl.textContent = countdownStr;
        countdownEl.hidden = false;
        suffixEl.textContent = parts[1] || '';
      } else {
        showCountdown = false;
        const afterState = getState(now);
        message = messages[afterState.key] || '';
        prefixEl.textContent = message;
        countdownEl.textContent = '';
        countdownEl.hidden = true;
        suffixEl.textContent = '';
      }
    } else {
      if (message.includes(timePlaceholder)) {
        const parts = message.split(timePlaceholder);
        prefixEl.textContent = parts[0] || '';
        countdownEl.textContent = cutoffTime;
        countdownEl.hidden = false;
        suffixEl.textContent = parts[1] || '';
      } else {
        prefixEl.textContent = message;
        countdownEl.textContent = '';
        countdownEl.hidden = true;
        suffixEl.textContent = '';
      }
    }
  }

  update();
  const interval = setInterval(update, 1000);

  el.dataset.initialized = 'true';
  return () => clearInterval(interval);
}

function initAllBadges() {
  document.querySelectorAll('[data-delivery-timer-badge]').forEach((el) => {
    if (el.dataset.initialized) return;
    initDeliveryTimerBadge(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllBadges);
} else {
  initAllBadges();
}

document.addEventListener('shopify:section:load', initAllBadges);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    setTimeout(initAllBadges, 150);
  });
}

// Expose for cart drawer to call after DOM updates (avoids race when footer is replaced async)
window.initDeliveryTimerBadges = initAllBadges;
